export default __webpack_public_path__ + "static/media/mine.min.94f48e69.png";